export const WISHLIST_ITEM_CLASS = 'qala-wishlist-button';
export const WISHLIST_CONTAINS_ITEM_CLASS = `${ WISHLIST_ITEM_CLASS }__is-in-wishlist`;
export const WISHLIST_DOES_NOT_CONTAIN_ITEM_CLASS = `${ WISHLIST_ITEM_CLASS }__is-not-in-wishlist`;
export const WISHLIST_IS_LOADED_CLASS = `${ WISHLIST_ITEM_CLASS }__is-loaded`;
export const WISHLIST_IS_LOADING_CLASS = `${ WISHLIST_ITEM_CLASS }__is-loading`;
export const HEADER_BUTTON_IS_EMPTY_CLASS = 'count__is-empty';
export const WISHLIST_BUTTON_NO_IMAGE_SLIDER_CLASS = `${ WISHLIST_ITEM_CLASS }__no-image-slider`;
export const WISHLIST_BUTTON_PULSE_CLASS = 'count--pulse';
